// <- TaskManagment.js
import React, { useState, useEffect, Fragment, useRef } from "react";
import { Button, Input, Row, Col, Form } from "reactstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TimePicker from 'react-time-picker';
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';
import moment from 'moment';
import "../../../style/calendarclass.css";
import useFormValidation from "../../common/useFormValidation";
import AddDeleteTableRowsTask from "../../../pages/tasks/AddDeleteTableRowsTask";
import Notifications from "../../../components/common/Notifications";
import { event } from "react-ga";
import api from "../../../apis/api";
import { useAuth } from "../../../context/AuthContext";
const loginUser = JSON.parse(localStorage.getItem("user"));
let allowedDates=[];

const AddEditTask = React.memo(
  ({
    handleClsAddEditTaskForm,
    handleAddUpdateTask,
    selectedTask,
    taskProjectInfo,
    addOrEdit,
    getAllTaskOfEmployee,
    setIsOpenAddEditForm,
    unlockReqList,
    LeaveReq,
    handleCloseAddEditForm,
    datearraylast,
    datearray,
    datearraylastAll,
    updatestatus,
    isInitialRender,
    isOpenAddEditForm,
    LeaveReqList,
    datearraylastdisable,
    dutytypeList,
    autoDutyType,
    recHolidayList,
    plannedLeaveList
  }) => {
    const [workDate, setWorkDate] = useState(new Date());
    const [absentDate, setAbsentDate] = useState(new Date());
    const [dueDate, setDueDate] = useState(new Date());
    const [taskTitle, setTaskTitle] = useState("");
    const [assignee, setAssignee] = useState("");
    const [hourSpent, setHourSpent] = useState("");
    const [hourBillable, setHourBillable] = useState("");
    const [estimatedHour, setEstimatedHour] = useState("");
    const [status, setStatus] = useState("0");
    const [type, setType] = useState("0");
    const [description, setDescription] = useState("");
   // const [taskId, setTaskId] = useState("");
    const[leaveStatus,setLeaveStatus] = useState(0);
    const[leaveType,setLeaveType] = useState(0);
    const [workTime, setWorkTime] = useState("09:30");
    const dates = [];
    const [leaveReq,setleaveReq]=useState([]);
    const [employeeFormValidation, setEmployeeFormValidation] = useState({});
    const [tasttrackingList, setTaskTrackingList] = useState([]);
    const [tasktrackList,settasktrackList] =useState([]);
    const [error, setError] = useState(null);
    const callValidation = useRef(false);
    const [value,setValue] =useState("");
    const [isdisableclicked,setisdisableclicked] =useState(false);
    const [duration, SetDuration] = useState(0);
    const [createdDate, setCreatedDate] = useState(new Date(workDate));
    const [projects, setProjects] = useState([]);      
    const [selectedProject, setSelectedProject] = useState("");
    const [isProjectDropdownOpen, setIsProjectDropdownOpen] = useState(false);
    const [isEditingProject, setIsEditingProject] = useState(false);
    const [isProjectEditing, setIsProjectEditing] = useState(false);
    const [isFormDisabled, setIsFormDisabled] = useState(false); // 
    const [projectUpdateSuccess, setProjectUpdateSuccess] = useState(false);
    const { user, logout } = useAuth();
  //---------------set Calendar Enable Dates-----------------------------
  
  var curr = new Date;  
 const t =new Date(curr.setDate(curr.getDate() - curr.getDay()+1)).getDate();
    const { formValidation, isFormValid } = useFormValidation(
      employeeFormValidation
    );
 
    var firstday = new Date(curr.setDate(curr.getDate() - curr.getDay()+1)).getDate();
    let lastFriday = new Date();
    let lastFridayl = new Date();
    lastFridayl.setDate(t);
  // put these helpers near where you currently compute allowedDates (inside component)

const getAllowedFrom = (refDate) => {
  const now = moment(refDate || new Date());

  const thisMonday = now.clone().startOf("week").add(1, "day"); // Monday this week
  const prevMonday = thisMonday.clone().subtract(7, "days");   // Monday last week

  const wednesdayCutoff = thisMonday.clone().hour(12).minute(10).second(0); // Wed 23:00

  console.log(
    "cutoff debug -> now:", now.format("YYYY-MM-DD HH:mm"),
    "thisMonday:", thisMonday.format("YYYY-MM-DD"),
    "prevMonday:", prevMonday.format("YYYY-MM-DD"),
    "cutoff:", wednesdayCutoff.format("YYYY-MM-DD HH:mm")
  );

  return now.isBefore(wednesdayCutoff) ? prevMonday : thisMonday;
};

function getDatesInRangeSimple(startDate, endDate) {
  const d = new Date(startDate);
  const end = new Date(endDate);
  const out = [];
  while (d <= end) {
    out.push(moment(new Date(d)).format("YYYY-MM-DD"));
    d.setDate(d.getDate() + 1);
  }
  return out;
}

// ---------- build allowedDates ----------
let baseAllowed = [];

// 1) existing unlock requests (keep your old behaviour)
if (unlockReqList && unlockReqList.length > 0 && unlockReqList[0] !== "") {
  unlockReqList.forEach((emp) => {
    const fromDate = moment(emp.fromDate).format("YYYY-MM-DD");
    const toDate = moment(emp.toDate).format("YYYY-MM-DD");
    const range = getDatesInRangeSimple(fromDate, toDate);
    baseAllowed = baseAllowed.concat(range);
  });
} else {
  // default behaviour if no unlock requests: Monday.. +7 days (your original logic)
  const curr = new Date();
  const today = new Date(curr);

  const monday = new Date(curr);
  monday.setDate(curr.getDate() - curr.getDay() + 1);

  const fromDate = curr.getDay() === 1 ? today : monday;
  const toDate = new Date();
  toDate.setDate(toDate.getDate() + 7);

  const range = getDatesInRangeSimple(fromDate, toDate);
  baseAllowed = baseAllowed.concat(range);
}

// 2) cutoff logic: allowedFrom (prev or this Monday)
const allowedFrom = getAllowedFrom( new Date());

// 3) include future dates from allowedFrom up to N days ahead (here: 365 days)
const futureEnd = moment().add(365, "days").endOf("day");
const extraAllowed = [];
let cursor = moment(allowedFrom);
while (cursor.isSameOrBefore(futureEnd, "day")) {
  extraAllowed.push(cursor.format("YYYY-MM-DD"));
  cursor.add(1, "day");
}

// 4) merge and dedupe (and keep as array)
allowedDates = Array.from(new Set([...baseAllowed, ...extraAllowed]));


      let holidaylist=[];
        recHolidayList.map(function (hol){
        holidaylist.push(moment(hol.holidayDate).format('YYYY-MM-DD'));
      });
    const errorRef = useRef(null);
    const errorRefnew = useRef(false);
    const [checkValue,setcheckValue] =useState(0);
    //-------------------------------------------------------------------
    const handleKeyPress = (event) => {
      setcheckValue(1);
      errorRefnew.current = true;
    };

    const handleEditProject = () => {
  setIsProjectEditing(true);
  setIsFormDisabled(true); // disable all other form fields
};
const updateEmployeeTimeSheetProject = async () => {
  if (!selectedProject || !selectedTask?.employeeTimeSheetId) return;

  try {
    const response = await api.dailytask().UpdateEmployeeTimeSheetProject(
      selectedTask.employeeTimeSheetId,
      selectedProject,
      parseInt(loginUser?.EmployeeId)
    );

  if (
  response.data?.message &&
  response.data.message.toLowerCase().includes("project updated successfully")
) {
  setIsProjectEditing(false);      // disable dropdown
  setIsFormDisabled(false);        // enable all other fields
  setProjectUpdateSuccess(true);  
    setTimeout(() => setProjectUpdateSuccess(false), 3000); // show success msg
} else {
  setProjectUpdateSuccess(false);
  alert("Failed to update project");
}
  } catch (err) {
    console.error("Error updating project:", err);
    setProjectUpdateSuccess(false);
    alert("Error updating project");
  }
};
    useEffect(() =>{
if(isOpenAddEditForm === true)
  {
    setcheckValue(0);
  }
  if (loginUser?.EmployeeId) {
api.project()
      .getProjectsOfEmployee(loginUser.EmployeeId)
      .then((res) => {
        setProjects(res.data); // assuming res.data is the array of projects
      })
      .catch((err) => {
        console.error("Error fetching projects: ", err);
      });
  }

    },[isOpenAddEditForm])
    useEffect(()=>{   
      window.addEventListener('keydown', handleKeyPress);
     
if(checkValue === 0)
  {
    errorRef.current.scrollIntoView();
    if (errorRefnew.current === true) 
    {
    setcheckValue(1);
    }
  }

  });
  // window.onbeforeunload = function () {
  //   errorRef.current.scrollIntoView();
  // }
    useEffect(() =>{
      callValidation.current && handleSubmitForm();
     
    },[formValidation]);
    const handledatepicker = (() =>{
      setcheckValue(1);
    })
    const formValidationOnSubmit = (e) => {
      e.preventDefault();
      let formValidationList = {
        taskTitle: {
          required: true,
          isValid: true,
          value: String(taskTitle),
          errorMessage: "",
        },
        workTime:{
          required: true,
          isValid: true,
          value: workTime,
          errorMessage: "",
        },
     
        estimatedHour:{
          required: true,
          isValid: true,
          value:parseInt(leaveType)===2 ? 0 : (parseInt(leaveType)===1 ? 4 :estimatedHour),
          errorMessage: "",
        },
       
      };
      setEmployeeFormValidation(formValidationList); //this set call the custom hook useFormValidation.
      callValidation.current = true;
    };
    useEffect(() => {
     
      setleaveReq(LeaveReq);
      setEmployeeFormValidation({});
   
      if (addOrEdit === "edit" && selectedTask!=null) { 
        settasktrackList([]);
        setisdisableclicked(true);      
        setTaskTitle(selectedTask.issueTitle);
        setAssignee();
        setWorkDate(new Date(selectedTask.workDate));
         setDueDate(new Date((selectedTask.dueDate === "0001-01-01T00:00:00" || selectedTask.dueDate === undefined) ? selectedTask.workDate : selectedTask.dueDate));
        setHourSpent(selectedTask.hoursSpent);
        setHourBillable(selectedTask.hoursBillable);
        setEstimatedHour(selectedTask.estimatedHour)
        setStatus(selectedTask.timeSheetStatus);
        setDescription(selectedTask.description);
        setLeaveStatus(selectedTask.leaveStatus);
        setLeaveType(selectedTask.leaveType);
        
        if (selectedTask.absentDate && selectedTask.absentDate !== "0001-01-01T00:00:00" && new Date(selectedTask.absentDate).getFullYear() > 1900) {
          setAbsentDate(new Date(selectedTask.absentDate));
        } else {
          setAbsentDate(null);
        }
        
        settasktrackList(selectedTask.employeeTimeSheetStatuses);
        setTaskTrackingList(selectedTask.employeeTimeSheetStatuses)
        if(selectedTask.startTime != null)
          {
            const time=selectedTask.startTime.split(' ');
            const stime=time[1];
            setWorkTime(stime);
          }
        
      //  setTaskId(selectedTask.employeeTimeSheetId);
      } else {
        SetDuration(0);
        setisdisableclicked(false); 
        setTaskTitle("");
        setAssignee("");
        setWorkDate(new Date());
        setAbsentDate(null);
        setDueDate(new Date());
        setHourSpent("");
        setHourBillable("");
        setStatus("0");
        setType("0");
        setDescription(" ");
        setLeaveStatus(0);
        setLeaveType(0);
        settasktrackList([]);
        setTaskTrackingList([]);
        setEstimatedHour("");
        setWorkTime("09:30")
      }
    }, [selectedTask, addOrEdit,LeaveReq,setisdisableclicked,settasktrackList]);
    var array = ["2023-05-16", "2023-05-12", "2023-05-15"];
    // var value1 = "2023-05-12"; 
    function isInArray(LeaveReq, value) {
      const newlist=LeaveReq.find(item =>moment(item.fromDate).format("YYYY-MM-DD") == value);
     return newlist;  
    }
    // Functions.
    // handle change date in DOJ
    const handleAlreadyLeave=() =>{
      errorRef.current.scrollIntoView();
      setError({ ...error, message: "Cannot add task on full day leave..", status: 500 });
    }
    const handleChangeStartDate = (date) => {
      SetDuration(0);
      const gg=LeaveReqList;
      const value1=moment(date).format('YYYY-MM-DD');
      const status=isInArray(LeaveReqList, value1);
      const nn=dueDate;
      setCreatedDate(date);
      const fetchapi=async () =>{ 
       const result=  await api.dbAttendance().getduration(parseInt(loginUser.EmployeeId),value1);
                         if(result.data.duration == '00:00:00')
                          {
                            var type=dutytypeList.filter((el) => el.type === "Work From Home");
                            setType(type[0].dutyTypeId);
                          
                          }
                          else{
                            var type=dutytypeList.filter((el) => el.type === "Work From Office");
                            setType(type[0].dutyTypeId);
                      
                              const [hours, minutes, seconds] = result.data.duration.split(":").map(Number);
                               const minute= hours * 3600 + minutes * 60 + seconds;
                            SetDuration(minute);
                          }
                          if(moment(date).format("YYYY-MM-DD")<=moment(dueDate).format("YYYY-MM-DD"))
        {
          setWorkDate(date);
          setLeaveStatus(false);
        }
        else
        {
          errorRef.current.scrollIntoView();
          setError({ ...error, message: "Created date less than due date..", status: 500 });
        }
                        }
                        fetchapi();
      
      
    };
    const handleChangeDueDate =React.useCallback ((date) => {
      const nn=dueDate;
      if(moment(workDate).format("YYYY-MM-DD")<=moment(date).format("YYYY-MM-DD"))
        {
      setDueDate(date);
        }
        else
        {
          errorRef.current.scrollIntoView();
          setError({ ...error, message: "Due date greater than created date..", status: 500 });
        }
      // const nn=workDate;
      // const value1=moment(date).format('YYYY-MM-DD');
      // const status=isInArray(LeaveReq, value1);
      // if(date<workDate)
      // {
      //   setError({ ...error, message: "Please Select A Due Date Later Than Or Equal To The Creation Date..", status: 500 });
      //   setDueDate(new Date());
      // }
      // if(status==false)
      // {
      //   setLeaveType(0);
      //   setLeaveStatus(false);
      // }
      // else
      // {
      //   setLeaveType("2");
      //   setLeaveStatus(true);
      // }
    },[setLeaveType,setLeaveStatus,LeaveReq,workDate]);
    const handleChangeStartTime = (date) => {
      setWorkTime(date.target.value);
    };
    const inputDateFormatString = (workDate)=>{
      var year = workDate.getFullYear();
      var month = workDate.getMonth() + 1;
      if(month <= 9)
          month = '0'+month;
      var day= workDate.getDate();
      if(day <= 9)
          day = '0'+day;
          var prettyDate = year +'-'+ month +'-'+ day;
          return prettyDate;
    };
    const getSafeAbsentDate = (absentDateVal) => {
      if (!absentDateVal) return null;
      const d = new Date(absentDateVal);
      if (isNaN(d.getTime()) || d.getFullYear() <= 1900) {
        return null;
      }
      return inputDateFormatString(d);
    };
    const mark = [
      '12-05-2023'
  ];
  const handledelteall =() =>{
    setTaskTitle("");
    setWorkDate(new Date());
    setAbsentDate(null);
    setDueDate(new Date());
    setHourSpent("");
    setHourBillable("");
    setStatus("0");
    setType("0");
    setDescription(" ");
    setLeaveStatus(0);
    setLeaveType(0);
    settasktrackList([]);
    setTaskTrackingList([]);
    setEstimatedHour("");
    setSelectedProject("");   
  }
    // handle form submite.
    const handleSubmitForm = (e) => {
      //  e.preventDefault();    
      if (isFormValid) {

          // ✅ Check all rows first
  if (tasttrackingList.length > 0) {
    for (let i = 0; i < tasttrackingList.length; i++) {
      const spent = parseFloat(tasttrackingList[i].hoursspent || 0);
      const billable = parseFloat(tasttrackingList[i].hoursbillable || 0);
      if (billable > spent) {
        alert(`Hours billable cannot be greater than hours spent.`);
        return; // stop submission
      }
       // 🚫 Validation 2: Any value > 24
    if (spent > 24 || billable > 24) {
      alert(`Hours spent or hours billable cannot exceed 24 hours.`);
      return; // stop submission
    }
    }
  } else {
    // single-entry check
    const spent = parseFloat(hourSpent || 0);
    const billable = parseFloat(hourBillable || 0);
    if (billable > spent) {
      alert("Hours billable cannot be greater than hours spent.");
      return; // stop submission
    }
     // 🚫 Validation 2: Any value > 24
    if (spent > 24 || billable > 24) {
      alert(`Hours spent or hours billable cannot exceed 24 hours.`);
      return; // stop submission
    }
  }
        if(moment(workDate).format("YYYY-MM-DD")<=moment(dueDate).format("YYYY-MM-DD"))
          {
            let timetrackArray = [];
            // if(addOrEdit === "edit")
            if(tasttrackingList.length >0)
            {
            for(var i=0;i<tasttrackingList.length;i++){
              const rowDate = tasttrackingList[i].startdate || tasttrackingList[i].statusDate;
              const formattedRowDate = rowDate ? inputDateFormatString(new Date(rowDate)) : inputDateFormatString(workDate);

             let timetrack_data = {
                  // "goalsAchievedId":goalsAchievedArr[i].goalAchievedId?goalsAchievedArr[i].goalAchievedId: 0,
                  "timesheetStatusId":parseInt(tasttrackingList[i].timesheetStatusId == null ? 0 : tasttrackingList[i].timesheetStatusId),
                  "employeeTimeSheetId" : addOrEdit === "edit" ? selectedTask.employeeTimeSheetId : 0,
                  "status" :parseInt(tasttrackingList[i].status =='' ? 0 : tasttrackingList[i].status) ,
                  "employeeId" : parseInt(loginUser.EmployeeId),
                  "statusDate": formattedRowDate,
                  "absentDate": getSafeAbsentDate(tasttrackingList[i].absentdate),
                  "hoursLogged":tasttrackingList[i].hoursLogged == undefined ? (parseFloat(tasttrackingList[i].hoursspent =='' ? 0 :tasttrackingList[i].hoursspent )) : parseFloat(tasttrackingList[i].hoursLogged =='' ? 0 :tasttrackingList[i].hoursLogged ),
                  "hoursBillable": tasttrackingList[i].hoursBillable == undefined ? (parseFloat(tasttrackingList[i].hoursbillable =='' ? 0 : tasttrackingList[i].hoursbillable)) : parseFloat(tasttrackingList[i].hoursBillable =='' ? 0 : tasttrackingList[i].hoursBillable),
                  "description":tasttrackingList[i].description,
                  "dutyTypeId":parseInt(tasttrackingList[i].dutyTypeId)
                  // "reviewerComment":goalsAchievedArr[i].comments      
                }
                timetrackArray.push(timetrack_data);
          }
        }
        else
        {
          let timetrack_data = {
            // "goalsAchievedId":goalsAchievedArr[i].goalAchievedId?goalsAchievedArr[i].goalAchievedId: 0,
            "employeeTimeSheetId" : addOrEdit === "edit" ? selectedTask.employeeTimeSheetId : 0,
            "status" :parseInt(status) ,
            "employeeId" : parseInt(loginUser.EmployeeId),
            "statusDate":inputDateFormatString(workDate) ,
            "absentDate": getSafeAbsentDate(absentDate),
            "hoursLogged": parseFloat(hourSpent),
            "hoursBillable":parseFloat(hourBillable),
            "description":description,
            "dutyTypeId":type
            // "reviewerComment":goalsAchievedArr[i].comments      
          }
          timetrackArray.push(timetrack_data);
        }
        // }
    
    
          let formDate = {
            employeeTimeSheetId: addOrEdit === "edit" ? selectedTask.employeeTimeSheetId
            : 0,
            employeeID: parseInt(loginUser.EmployeeId),
            workDate:inputDateFormatString(workDate),
             projectID: selectedProject || taskProjectInfo.projectId,
            issueID:0,    
            description:description,    
            hoursSpent: parseFloat(((leaveType=="2") && leaveStatus == true) ? 0 : hourSpent),
            hoursBillable: parseFloat(( (leaveType=="2") && leaveStatus == true) ? 0 : hourBillable),
            estimatedHour: parseFloat(( (leaveType=="2") && leaveStatus == true) ? 0 : estimatedHour),
            projectIssueStatus:1,
            endDate:inputDateFormatString(workDate),
            dueDate:inputDateFormatString(dueDate),
            timeSheetStatus:parseInt(status),
            createdBy: parseInt(loginUser.EmployeeId),
            createdDate:inputDateFormatString(createdDate),
            modifiedBy:parseInt(loginUser.EmployeeId),
            modifiedDate:inputDateFormatString(new Date()),
            issueTitle:taskTitle,
            assignedTo:parseInt(loginUser.EmployeeId),
            projectName: projects.find(p => p.projectID === selectedProject)?.projectName || taskProjectInfo.projectName,
            // taskId:
            // addOrEdit === "edit"
            //   ? selectedTask.employeeTimeSheetId
            //   : Math.floor(Math.random() * 100) + 1,
            leaveStatus : leaveStatus === true,
            leaveType : leaveStatus===true ? parseInt(leaveType):0,
            startTime : workTime,
            EmployeeTimeSheetStatuses:timetrackArray,
          };
        let arraynew=[];
          timetrackArray.forEach(element => {
            if(element.description =='' ||  element.hoursLogged == 0 || element.status ==0 || element.statusDate == null)
              {
                errorRef.current.scrollIntoView();
               if (errorRefnew.current === true) 
                {
                   setcheckValue(1);
                }
                setError({ ...error, message: "Please Enter All TimeLoggin Details..", status: 500 });
              }
              
                  else
                  {
                    arraynew.push(element);
                  }
          });
          if(arraynew.length == timetrackArray.length)
            {
              handleAddUpdateTask(formDate);
              handleClsAddEditTaskForm(addOrEdit);
              // handlecloseform(addOrEdit);
              getAllTaskOfEmployee();
              settasktrackList([]);
              setTaskTrackingList([]);
              setEmployeeFormValidation({});
              SetDuration(0);
            }
          }
          else
          {
            errorRef.current.scrollIntoView();
            setError({ ...error, message: "Due date less than work date..", status: 500 });
          }
     
      
      callValidation.current=false;
      //EmployeeTimeSheetStatuses getAllTaskOfEmployee(parseInt(loginUser.EmployeeId));
    }
   
    };
   const handlecloseform =(e) =>{
  handleClsAddEditTaskForm(e);
  handleCloseAddEditForm(e);

    // reset project edit state
  setIsProjectEditing(false);
  setIsFormDisabled(false);


  // Only reset form-specific fields
  setWorkTime("09:30");
  setHourSpent("");
  setHourBillable("");
  setEstimatedHour("");
  setDescription("");
  setStatus("0");
  setSelectedProject("");   
  settasktrackList([]);
  setTaskTrackingList([]);
  setEmployeeFormValidation({});
     setEstimatedHour("");
SetDuration(0);
  // Do NOT reset selectedTask or taskProjectInfo here
}
    const handelcancel=(e) =>{
      // handlecloseform(e);
      handleClsAddEditTaskForm(addOrEdit);
      handleCloseAddEditForm(e);
      setWorkTime("10:00");
      handledelteall();
      settasktrackList([]);
      setTaskTrackingList([]);
      setEmployeeFormValidation({});
    }
    const [time, onChange] = useState('10:00');
    
const setData = (data)=>{
  setTaskTrackingList(data)
  }
  const handletotcal =(name,value) =>{
    if(name==="hoursspent")
    {
      
        setHourSpent(value);
           
    }
    else if(name==="hoursbillable")
    {
      setHourBillable(value);
    }
    else if(name==="status")
    {
      setStatus(value);
    }
// alert("1");
  }
  const handledisable=React.useCallback((st)=>{
    if(st==1)
    {
      setisdisableclicked(true);
    }
    else
    {
      setisdisableclicked(false);
    }
    
  },[setisdisableclicked])
  const handlestatuschange=React.useCallback((e) =>{
SetDuration(e);
  },[SetDuration]);

  const uniqueProjects = projects.filter(
  (proj, index, self) =>
    index === self.findIndex((p) => p.projectID === proj.projectID)
);
const handleLogout = () => {
    logout();
  };
  // function isInArray(LeaveReq, value) {
  //   return (LeaveReq.find(item => {return item == value}) || []).length > 0;
  // }
    return (
      <Fragment>
        <Form id="topview">
        <div ref={errorRef}>
          <div hidden={true}>
      <p>Welcome {user?.name}</p>
      <button onClick={handleLogout}>Logout</button>
    </div>
          <div className="fixed-header">
            <div>
            {selectedTask != ''? (<Button size="sm" outline className="secondary" onClick={() =>updatestatus(selectedTask)}>
                <i className="fas fa-check"></i> Mark Completed
              </Button>): null}  
              
              <div className="d-inline float-right ">
                <Button color="" onClick={(e) => handlecloseform(e)}>
                  <i className="fas fa-times text-muted"></i>
                </Button>
              </div>
            </div>
          </div>
          
          <div className="task-details">
            <div className="chat-wrap-inner">             
              <div className="chats"> 
<p style={{ color: "black" }}>
  Project Name: 
  <select
    style={{ marginLeft: "10px", padding: "2px" }}
    value={selectedProject || taskProjectInfo?.projectId || ""}
    onChange={(e) => setSelectedProject(parseInt(e.target.value))}
    disabled={addOrEdit === "edit" && !isProjectEditing} // dropdown enabled only during edit
  >
    {uniqueProjects.map((proj) => (
      <option key={proj.projectID} value={proj.projectID}>
        {proj.projectName}
      </option>
    ))}
  </select>

  {addOrEdit === "edit" && !isProjectEditing && (
    <Button
      size="sm"
      color=""
      onClick={() => {
        setIsProjectEditing(true);   // enable dropdown
        setIsFormDisabled(true);     // disable other fields while editing project
      }}
      style={{ marginLeft: "5px" }}
    >
      <i className="fas fa-pencil-alt"></i>
    </Button>
  )}

  {addOrEdit === "edit" && isProjectEditing && (
    <Button
      type="button"
      color=""
     style={{ marginLeft: "9px" }}
      className="btn-admin-settings"
      onClick={async () => {
        await updateEmployeeTimeSheetProject(); // API call
        setIsProjectEditing(false);            // disable dropdown after update
        setIsFormDisabled(false);              // enable all other fields
      }}
    >
      Save project
    </Button>
  )}

  {projectUpdateSuccess && (
    <span style={{ color: "green", marginLeft: "10px" }}>
      Project updated successfully!
    </span>
  )}
</p>

       
                <Input
                  type="text"
                  placeholder="Task Title"
                  onChange={(e) => setTaskTitle(e.target.value)}
                  value={taskTitle}
                  name="taskTitle"
                  disabled={isFormDisabled} 
                />
                {Object.keys(formValidation).length !== 0 &&
              !formValidation.taskTitle.isValid && (
                <span className=" " style={{ color: "red" }}>
                  {formValidation.taskTitle.errorMessage}
                </span>
              )}
              <br/>
                <div className="task-header">
                  <div className="assignee-info">
                    <div className="avatar">
                      <img
                        alt=""
                        src={require("../../../img/employee/user.png")}
                        // src={ employee.profilePicture == null ||  employee.profilePicture =='undefined'? (require(`../../../img/employee/user.png`)) : (require(`../../../img/employee/` + employee.profilePicture))}
                      />
                    </div>
                    <div className="assigned-info">
                      <div className="task-head-title">Assignee</div>
                      <div className="task-assignee">{loginUser.email}</div>
                    </div>
                  </div>
                  <div className="task-due-date">
                    <div className="due-icon">
                      <span>
                        <i className="fas fa-calendar-alt text-muted"></i>
                      </span>
                    </div>
                    <div className="due-info" style={{flexWrap:"nowrap"}}>
                      <div className="task-head-title">Created Date</div>
                      <div className="due-date">
                        <DatePicker 
                      
                          selected={new Date(workDate)}
                          onChange={handleChangeStartDate}
                          dateFormat="dd-MM-yyyy"
                          aria-label="Enter your text"
                          // minDate={lastFriday}
                          // includeDates={allowedDates}
                          filterDate={(d) => allowedDates.includes(moment(d).format('YYYY-MM-DD')) }
                          disabled={isFormDisabled || addOrEdit === "edit"}
                        />
                      </div>
                    </div>

           
                  </div>     
                  <div className="task-due-date">
                    <div className="due-icon">
                      <span>
                        <i className="fas fa-calendar-alt text-muted"></i>
                      </span>
                    </div>
                    <div className="due-info">
                      <div className="task-head-title">Due Date</div>
                      <div className="due-date">
                        <DatePicker 
                          selected={new Date(dueDate)}
                          onChange={handleChangeDueDate}
                          dateFormat="dd-MM-yyyy"
                          aria-label="Enter your text"
                          // minDate={lastFriday}
                          // includeDates={allowedDates}
                          filterDate={(d) => allowedDates.includes(moment(d).format('YYYY-MM-DD')) }
                          disabled={isFormDisabled || addOrEdit === "edit"}
                        />
                      </div>
                    </div>

           
                  </div>   
                  {/* <div className="task-due-date">
                  <li>

<div className="title">Start Time</div>
  <div className="text">
    <Input 
    type="time"
    onChange={date => { handleChangeStartTime( date )}}
    aria-label="Enter your text"
    value={workTime}
    name="workTime">
    </Input>

  </div>
  {Object.keys(formValidation).length !== 0 &&
!formValidation.workTime.isValid && (
<span className=" " style={{ color: "red" }}>
{formValidation.workTime.errorMessage}
</span>
)}
</li>
</div> */}
 <div className="task-due-date">
                  <li>

<div className="title">Estimate Hours</div>
<div className="text">
  <Input
    type="number"
    min="0"
   onChange={(e) => {
  let val = e.target.value;
  if (val === "") {
    setEstimatedHour(""); // allow clearing
  } else if (Number(val) < 0) {
    setEstimatedHour(0);  // negatives → 0
  } else {
    setEstimatedHour(val);
  }
}}
    value={(leaveType === "2" && leaveStatus === true) ? 0 : estimatedHour}
    name="estimatedHour"
    className="txttask_text"
    aria-label="Enter your text"
    disabled={isFormDisabled || isdisableclicked}
  />
</div>
  {Object.keys(formValidation).length !== 0 &&
              !formValidation.estimatedHour.isValid && (
                <span className=" " style={{ color: "red" }}>
                  {formValidation.estimatedHour.errorMessage}
                </span>
              )}
</li>
</div>


<div className="due-info">
                      <div className="task-head-title"> </div>
                      <div className="due-date" style={{paddingTop:"22px"}}>
                       <Button
                        type="submit"
                        color=""
                        className="btn-admin-settings"
                        onClick={(e) => formValidationOnSubmit(e)}
                        disabled={isFormDisabled} 
                        // disabled = {((leaveType == "2" && leaveStatus == true) ? "disabled" : null)}
                      >
                        {/* {selectProject ? "Update" : "Add"} */}
                        {addOrEdit === "add" ? "Add" : "Update"}
                      </Button>
                      </div>
                    </div>


                </div>
                <hr></hr>
                <div className="task-data ">
                 
          
                 
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
  <h4>Time Logging Details</h4>
  {duration != 0 ? (
    <h4>
      Inside Office Hours: {duration}
    </h4>
  ) : null}  
</div>
                  {/* {addOrEdit === "add" ? null :( */}
           {(parseInt(leaveType) == 2 || parseInt(leaveType) ==  1) ? null :(<AddDeleteTableRowsTask
                  setData={setData}
                  tasktrackList={tasktrackList}
                  handletotcal={handletotcal}
                  allowedDates={allowedDates}
                  datearray={datearray}
                  datearraylast={datearraylast}
                  unlockReqList={unlockReqList}
                  datearraylastAll={datearraylastAll}
                  datearraylastdisable={datearraylastdisable}
                  addOrEdit={addOrEdit}
                  handledatepicker={handledatepicker}
                  LeaveReq={LeaveReq}
                  handleAlreadyLeave={handleAlreadyLeave}
                  LeaveReqList={LeaveReqList}
                  handledisable={handledisable}
                  dutytypeList={dutytypeList}
                  holidaylist={holidaylist}
                  createdDate={createdDate}
                  handlestatuschange={handlestatuschange}
                  plannedLeaveList={plannedLeaveList}
                  isFormDisabled={isFormDisabled}
                  />)}   
     
                  {/* )  } */}
                  
                </div>
              </div>
            </div>
          </div>
          </div>

        </Form>
        <Notifications notifications={error}></Notifications>
      </Fragment>

    );
  }
);
export default AddEditTask;
